module.exports = __webpack_public_path__ + "static/cloud PBX-20770c5a027242a23894143ea4829b04.png";